import { Attachment } from '../attachments/attachment.model';
import { Product } from '../../core/services/products/product.model';
import { AttachmentType } from '../attachments/attachment-type.enum';
import { Contact } from '../../core/services/user/contact.model';
import { SubsidyType } from '../../models/subsidy-type.type';

export class SubsidyDossier {
	id: number;
	applicationContact: Contact;
	attachments: Attachment[];
	baseProduct: Product;
	bic: string;
	caseNumber: string;
	descriptionComment: string;
	descriptionUnclear: boolean;
	grantedSubsidyAmount: number;
	iban: string;
	missingDocumentsComment: string;
	projectTitle?: string;
	remainingSubsidyAmount: number;
	requiredAttachments: AttachmentType[];
	showFeedback: boolean;
	subsidyStatus: string;
	subsidySubStatus: string;
	type: SubsidyType;
	subtype?: string;

	constructor(obj: any = {}) {
		this.id = obj.id;
		this.applicationContact = obj.applicationContact;
		this.attachments = obj.attachments;
		this.baseProduct = obj.baseProduct;
		this.bic = obj.bic;
		this.caseNumber = obj.caseNumber;
		this.descriptionComment = obj.descriptionComment;
		this.descriptionUnclear = obj.descriptionUnclear;
		this.grantedSubsidyAmount = obj.grantedSubsidyAmount;
		this.iban = obj.iban;
		this.missingDocumentsComment = obj.missingDocumentsComment;
		this.projectTitle = obj.projectTitle;
		this.remainingSubsidyAmount = obj.remainingSubsidyAmount;
		this.requiredAttachments = obj.requiredAttachments;
		this.showFeedback = obj.showFeedback;
		this.subsidyStatus = obj.subsidyStatus;
		this.subsidySubStatus = obj.subsidySubStatus;
		this.type = obj.type ? obj.type.toLowerCase() : null;
		this.subtype = obj.subtype;
	}
}
